"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

require("./MyDatePicker.css");

var _OzIcon = _interopRequireDefault(require("./../OzIcon/OzIcon.js"));

var _OzButton = _interopRequireDefault(require("./../OzButton/OzButton.js"));

var _consts = require("./../consts.js");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react.default.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Wrapper",
  componentId: "sc-10cofk-0"
})(["\n  text-align: left;\n  user-select: none;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n  input::-webkit-calendar-picker-indicator{\n    display: none;\n  }\n"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Container",
  componentId: "sc-10cofk-1"
})(["\n  position: relative;\n  display: block;\n  width: ", ";\n  max-width: 100%;\n  display: flex;\n"], function (props) {
  return props.width;
});

var InputGroupCnt = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__InputGroupCnt",
  componentId: "sc-10cofk-2"
})(["\n  margin-bottom: 15px;\n"]);

var InputGroup = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__InputGroup",
  componentId: "sc-10cofk-3"
})(["\n  position: relative;\n  display: block;\n  width: ", ";\n  max-width: 100%;\n  display: flex;\n\n  & :not(:last-child) *{\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n    border-right: 0px;\n  }\n  & :not(:first-child) *{\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n  }\n\n  ", "\n"], function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.open ? "\n    & :first-child *{\n      border-bottom-left-radius: 0px !important;\n    }\n    & :last-child *{\n      border-bottom-right-radius: 0px !important;\n    }\n  " : null;
});

var InputContainer = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__InputContainer",
  componentId: "sc-10cofk-4"
})(["\n  position: relative;\n  width: 100%;\n"]);

var Clear = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Clear",
  componentId: "sc-10cofk-5"
})(["\n  cursor: pointer;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: calc(", " - 16px);\n  height: calc(", " - 16px);\n  background-color: ", ";\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  z-index: 3;\n\n  /* box-shadow: 0px 1px 2px #687FE239; */\n\n  &:hover{\n    box-shadow: inset 0px 1px 2px #687FE239;\n"], function (props) {
  return props.height;
}, function (props) {
  return props.height;
}, _consts.LILAC);

var Input = _styledComponents.default.input.withConfig({
  displayName: "OzDatepicker__Input",
  componentId: "sc-10cofk-6"
})(["\n  font-family: 'Be Vietnam Pro', sans-serif;\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n\n  padding: 0px 10px;\n  height: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  outline: none;\n  box-sizing: border-box;\n  width: 100%;\n  flex-grow: 1;\n  flex-shrink: 1;\n\n  border-radius: 4px;\n\n  ", ";\n\n"], function (props) {
  return props.height;
}, function (props) {
  return props.variant === "default" ? "\n    background-color: " + (props.disabled ? "#F2F4FD" : "#ffffff") + ";\n    color: " + (props.disabled ? "#30303054" : _consts.BLACKPEARL) + ";\n    border: 1px solid " + _consts.BORDER + ";\n    box-shadow: inset 0px 1px 2px #687FE262;\n\n    ::placeholder {\n      color: #dedede;\n      opacity: 1;\n    }\n\n    :-webkit-autofill {\n      ".concat(function (props) {
    return props.disabled ? "\n        box-shadow: inset 0 0 0px 9999px #F2F4FD;\n      " : "\n        box-shadow: inset 0 0 0px 9999px #ffffff;\n      ";
  }, ";\n    }\n  ") : props.variant === "charcoal" ? "\n      background-color: " + (props.disabled ? "#F2F4FD" : "#455262") + ";\n      color: " + (props.disabled ? "#30303054" : "#FFFFFF") + ";\n      border: 1px solid" + _consts.BLACKPEARL + ";\n      box-shadow: inset 0px 1px 2px #20283362;\n\n      ::placeholder {\n        color: #FFFFFF;\n        opacity: 1;\n      }\n\n      :-webkit-autofill {\n        ".concat(function (props) {
    return props.disabled ? "\n          box-shadow: inset 0 0 0px 9999px #F2F4FD;\n        " : "\n          box-shadow: inset 0 0 0px 9999px #ffffff;\n        ";
  }, ";\n      }\n  ") : null;
});

var ClickCatcher = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__ClickCatcher",
  componentId: "sc-10cofk-7"
})(["\n  display: ", ";\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n"], function (props) {
  return props.open ? "block" : "none";
});

var Popup = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Popup",
  componentId: "sc-10cofk-8"
})(["\n  position: absolute;\n  left: 0;\n  top: ", ";\n  width: ", ";\n\n  background-color: #ffffff;\n  border: 1px solid #CBCBCB;\n  box-shadow: 0px 1px 2px #687FE262;\n\n  border-top-left-radius: 0px;\n  border-top-right-radius: 0px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n\n  margin-top: -1px;\n\n  padding: 15px 20px;\n  z-index: 99999;\n  display: flex;\n  flex-direction: column;\n"], function (props) {
  return props.top;
}, function (props) {
  return props.width;
});

var CalendarGroup = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__CalendarGroup",
  componentId: "sc-10cofk-9"
})(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n"]);

var Calendar = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Calendar",
  componentId: "sc-10cofk-10"
})(["\nmargin: 0px 2px;\n  // padding: 10px;\n"]);

var CalendarPrevButton = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__CalendarPrevButton",
  componentId: "sc-10cofk-11"
})(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-color: #ffffff;\n  border: 1px solid #CBCBCB;\n  box-shadow: 0px 1px 2px #687FE262;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  cursor: pointer;\n"]);

var CalendarNextButton = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__CalendarNextButton",
  componentId: "sc-10cofk-12"
})(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  background-color: #ffffff;\n  border: 1px solid #CBCBCB;\n  box-shadow: 0px 1px 2px #687FE262;\n  border-radius: 4px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  cursor: pointer;\n"]);

var CalendarHead = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__CalendarHead",
  componentId: "sc-10cofk-13"
})(["\n  width: 100%;\n  text-align: center;\n  font-weight: 700;\n  font-size: 13px;\n"]);

var CalendarBody = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__CalendarBody",
  componentId: "sc-10cofk-14"
})(["\n  float: left;\n  width: 100%;\n"]);

var Weekdays = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Weekdays",
  componentId: "sc-10cofk-15"
})(["\n  position: relative;\n  display: block;\n  float: left;\n  box-sizing: border-box;\n  width: 100%;\n  margin-top: 10px;\n"]);

var Weekday = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Weekday",
  componentId: "sc-10cofk-16"
})(["\n  position: relative;\n  display: block;\n  float: left;\n  box-sizing: border-box;\n  width: 14.285%;\n  text-align: center;\n\n  font-weight: 600;\n  font-size: 9px;\n"]);

var Days = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Days",
  componentId: "sc-10cofk-17"
})(["\n  position: relative;\n  display: block;\n  float: left;\n  box-sizing: border-box;\n  height: 200px;\n  width: 100%;\n"]);

var DayContainer = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__DayContainer",
  componentId: "sc-10cofk-18"
})(["\n  position: relative;\n  display: block;\n  float: left;\n  box-sizing: border-box;\n  width: 14.285%;\n  height: 16.6666%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  ", "\n"], function (props) {
  return props.isBetweenSelected && !props.isDisabled && !props.isSelected ? "\n    &::before{\n      display: block;\n      content: \"\";\n      position: absolute;\n      top: 5px;\n      height: 24px;\n      width: 100%;\n      background: " + _consts.LILAC + ";\n      z-index: 2;\n    }\n  " : props.isBetweenSelected && !props.isDisabled && props.isStart ? "\n    &::after{\n      display: block;\n      content: \"\";\n      position: absolute;\n      top: 5px;\n      right: 0px;\n      height: 24px;\n      width: 50%;\n      background: " + _consts.LILAC + ";\n      z-index: 2;\n    }\n  " : props.isBetweenSelected && !props.isDisabled && props.isEnd ? "\n    &::after{\n      display: block;\n      content: \"\";\n      position: absolute;\n      top: 5px;\n      left: 0px;\n      height: 24px;\n      width: 50%;\n      background: " + _consts.LILAC + ";\n      z-index: 2;\n    }\n  " : null;
});

var Day = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Day",
  componentId: "sc-10cofk-19"
})(["\n  cursor: pointer;\n  width: 50px;\n  height: 30px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n  color: #444;\n  padding-top: 1px;\n  position: relative;\n\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n  border: 2px solid #fff;\n  &:hover{\n    border-color: ", ";\n    background: #ffffff;\n  }\n\n\n  ", "\n    z-index: 3;\n"], _consts.CHETWODEBLUE, function (props) {
  return props.isDisabled ? "\n    pointer-events: none;\n    color: #ddd;\n  " : props.isSelected ? "\n    color: #fff;\n    background: " + _consts.CHETWODEBLUE + ";\n    &:hover{\n      border-color: " + _consts.CHETWODEBLUE + ";\n      background: " + _consts.CHETWODEBLUE + ";\n    }\n  " : props.isToday ? "\n    color: #000;\n    background: " + _consts.SILVERTREE + "55;\n    &:hover{\n      border-color: " + _consts.SILVERTREE + ";\n      background: " + _consts.SILVERTREE + ";\n    }\n  " : props.isBetweenSelected ? "\n    border-color: transparent;\n  " : null;
});

var DayNumber = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__DayNumber",
  componentId: "sc-10cofk-20"
})(["\n  z-index: 3;\n"]);

var Label = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Label",
  componentId: "sc-10cofk-21"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var Periods = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__Periods",
  componentId: "sc-10cofk-22"
})(["\n  margin-top: 10px;\n  border-top: 1px solid #CBCBCB; \n  margin-bottom: 5px;\n"]);

var PeriodsLabel = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__PeriodsLabel",
  componentId: "sc-10cofk-23"
})(["\n  color: ", ";\n  font-size: 11px;\n  font-weight: 700;\n  margin: 10px 0px;\n"], _consts.CHETWODEBLUE);

var PeriodsButtons = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__PeriodsButtons",
  componentId: "sc-10cofk-24"
})(["\n  gap: 5px;\n  display: flex;\n  flex-direction: row;\n  white-space: nowrap;\n  flex-wrap: wrap;\n"]);

var ButtonCnt = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__ButtonCnt",
  componentId: "sc-10cofk-25"
})(["\n  ", "\n\n  ", "\n  \n"], function (props) {
  return props.open ? "\n    & *{\n      border-bottom-right-radius: 0px !important;\n      border-bottom-left-radius: 0px !important;\n    }\n  " : null;
}, function (props) {
  return props.active ? "\n    & *{\n      color: " + _consts.CHETWODEBLUE + " !important;\n    }\n  " : null;
});

var FormGroup = _styledComponents.default.div.withConfig({
  displayName: "OzDatepicker__FormGroup",
  componentId: "sc-10cofk-26"
})(["\n  \n  & > *:first-child{\n    border-top-right-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;    \n    width: 50px;\n    text-align: center;\n    position: relative;\n    border-right: 0px;\n    bottom: -1px;\n  }\n  & > *:last-child{\n    border-top-left-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;    \n  }\n"]);

var OzDatepicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OzDatepicker, _Component);

  var _super = _createSuper(OzDatepicker);

  function OzDatepicker() {
    var _this;

    (0, _classCallCheck2.default)(this, OzDatepicker);
    _this = _super.call(this);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      getMonthDetails: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "daysMap", ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "monthMap", ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDayDetails", function (args) {
      var date = args.index - args.firstDay;
      var day = args.index % 7;
      var prevMonth = args.month - 1;
      var prevYear = args.year;

      if (prevMonth < 0) {
        prevMonth = 11;
        prevYear--;
      }

      var prevMonthNumberOfDays = _this.getNumberOfDays(prevYear, prevMonth);

      var _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;

      var month = date < 0 ? -1 : date >= args.numberOfDays ? 1 : 0;
      var timestamp = new Date(args.year, args.month, _date).getTime();
      return {
        date: _date,
        day: day,
        month: month,
        timestamp: timestamp,
        dayString: _this.daysMap[day]
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNumberOfDays", function (year, month) {
      return 40 - new Date(year, month, 40).getDate();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMonthDetails", function (year, month) {
      var firstDay = new Date(year, month).getDay();

      var numberOfDays = _this.getNumberOfDays(year, month);

      var monthArray = [];
      var rows = 6;
      var currentDay = null;
      var index = 0;
      var cols = 7;

      for (var row = 0; row < rows; row++) {
        for (var col = 0; col < cols; col++) {
          currentDay = _this.getDayDetails({
            index: index,
            numberOfDays: numberOfDays,
            firstDay: firstDay,
            year: year,
            month: month
          });
          monthArray.push(currentDay);
          index++;
        }
      }

      return monthArray;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDateFromDateString", function (dateValue) {
      var dateData = dateValue.split('-').map(function (d) {
        return parseInt(d, 10);
      });
      if (dateData.length < 3) return null;
      var year = dateData[0];
      var month = dateData[1];
      var date = dateData[2];
      return {
        year: year,
        month: month,
        date: date
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMonthStr", function (month) {
      return _this.monthMap[Math.max(Math.min(11, month), 0)] || 'Month';
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDateStringFromDate", function (jsdate) {
      var dateObject = new Date(jsdate);
      var month = dateObject.getMonth() + 1;
      var date = dateObject.getDate();
      return dateObject.getFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateDateFromInputStart", function (e) {
      var dateData = _this.getDateFromDateString(e.target.value);

      if (dateData !== null) {
        var selectedDay = new Date(dateData.year, dateData.month - 1, dateData.date).getTime();

        if (_this.props.type === "range") {
          _this.onChange(selectedDay, selectedDay);

          _this.setState({
            rangeStart: selectedDay
          });
        } else {
          _this.onChange(selectedDay);
        }

        _this.setState({
          year: dateData.year,
          month: dateData.month - 1,
          monthDetails: _this.getMonthDetails(dateData.year, dateData.month - 1)
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateDateFromInputEnd", function (e) {
      var dateData = _this.getDateFromDateString(e.target.value);

      if (dateData !== null) {
        var selectedDay = new Date(dateData.year, dateData.month - 1, dateData.date).getTime();

        if (_this.state.rangeStart < selectedDay) {
          _this.onChange(_this.state.rangeStart, selectedDay);
        } else {
          _this.onChange(selectedDay, _this.state.rangeStart);
        }

        _this.setState({
          year: dateData.year,
          month: dateData.month - 1,
          monthDetails: _this.getMonthDetails(dateData.year, dateData.month - 1)
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setYear", function (offset) {
      var year = _this.state.year + offset;
      var month = _this.state.month;

      _this.setState({
        year: year,
        monthDetails: _this.getMonthDetails(year, month)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setMonth", function (offset) {
      var year = _this.state.year;
      var month = _this.state.month + offset;

      if (month === -1) {
        month = 11;
        year--;
      } else if (month === 12) {
        month = 0;
        year++;
      }

      _this.setState({
        year: year,
        month: month,
        monthDetails: _this.getMonthDetails(year, month)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function () {
      var date1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var date2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // if(date2){
      _this.props.onChange(date1 ? new Date(date1) : null, date2 ? new Date(date2) : null); // }else{
      //   this.props.onChange(new Date(date1));
      // }

    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isSameDay", function (date1, date2) {
      if (date1 instanceof Date && !isNaN(date1) && date2 instanceof Date && !isNaN(date2)) {
        return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
      } else {
        return false;
      }
    });

    var _date2 = new Date();

    var tempYear = _date2.getFullYear();

    var tempMonth = _date2.getMonth();

    _this.state = {
      shortcutDays: 3,
      shortcutWeeks: 2,
      year: tempYear,
      month: tempMonth,
      monthDetails: _this.getMonthDetails(tempYear, tempMonth),
      rangeStart: null
    };
    return _this;
  }

  (0, _createClass2.default)(OzDatepicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __jsx(Wrapper, null, this.props.label ? __jsx(Label, null, this.props.label, " ", this.props.required ? "*" : "") : null, __jsx(Container, {
        width: this.props.compact ? "auto" : this.props.width ? this.props.width : this.props.type === "range" ? "520px" : "260px"
      }, this.props.compact ? __jsx(ButtonCnt, {
        open: this.state.open,
        active: this.props.startValue || this.props.endValue
      }, __jsx(_OzButton.default, {
        variant: "push-black",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.setState({
            open: true
          });
        }
      }, this.props.buttonLabel ? this.props.buttonLabel : "Date")) : __jsx(InputGroup, {
        open: this.state.open
      }, __jsx(InputContainer, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "100%",
        height: this.props.height ? this.props.height : "34px",
        type: "date",
        disabled: this.props.disabled,
        onChange: function onChange(e) {
          return _this2.updateDateFromInputStart(e);
        },
        value: this.props.type === "range" ? this.props.startValue ? this.getDateStringFromDate(this.props.startValue) : false : this.props.value ? this.getDateStringFromDate(this.props.value) : false,
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.setState({
            open: true
          });
        },
        required: true
      }), this.props.type !== "range" && this.props.value || this.props.type === "range" && this.props.startValue !== false ? __jsx(Clear, {
        height: this.props.height ? this.props.height : "34px",
        onClick: function onClick() {
          _this2.onChange(null, null);
        }
      }, __jsx(_OzIcon.default, {
        size: "14px",
        name: "x",
        color: _consts.BLACKPEARL
      })) : null), this.props.type === "range" ? __jsx(InputContainer, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "100%",
        height: this.props.height ? this.props.height : "34px",
        type: "date",
        disabled: this.props.disabled,
        onChange: function onChange(e) {
          return _this2.updateDateFromInputEnd(e);
        },
        value: this.props.endValue ? this.getDateStringFromDate(this.props.endValue) : false,
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.setState({
            open: true
          });
        },
        required: true
      }), this.props.endValue !== false ? __jsx(Clear, {
        height: this.props.height ? this.props.height : "34px",
        onClick: function onClick() {
          _this2.onChange(_this2.props.startValue, null);
        }
      }, __jsx(_OzIcon.default, {
        size: "14px",
        name: "x",
        color: _consts.BLACKPEARL
      })) : null) : null), this.state.open ? __jsx(Popup, {
        width: this.props.width ? this.props.width : this.props.type === "range" ? "520px" : "260px",
        top: this.props.height ? this.props.height : "34px"
      }, this.props.compact ? __jsx(InputGroupCnt, null, __jsx(InputGroup, {
        width: this.props.width ? this.props.width : this.props.type === "range" ? "520px" : "260px"
      }, __jsx(InputContainer, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "100%",
        height: this.props.height ? this.props.height : "34px",
        type: "date",
        disabled: this.props.disabled,
        onChange: function onChange(e) {
          return _this2.updateDateFromInputStart(e);
        },
        value: this.props.type === "range" ? this.props.startValue ? this.getDateStringFromDate(this.props.startValue) : false : this.props.value ? this.getDateStringFromDate(this.props.value) : false,
        required: true
      }), this.props.type !== "range" && this.props.value || this.props.type === "range" && this.props.startValue !== false ? __jsx(Clear, {
        height: this.props.height ? this.props.height : "34px",
        onClick: function onClick() {
          _this2.onChange(null, null);
        }
      }, __jsx(_OzIcon.default, {
        size: "14px",
        name: "x",
        color: _consts.BLACKPEARL
      })) : null), this.props.type === "range" ? __jsx(InputContainer, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "100%",
        height: this.props.height ? this.props.height : "34px",
        type: "date",
        disabled: this.props.disabled,
        onChange: function onChange(e) {
          return _this2.updateDateFromInputEnd(e);
        },
        value: this.props.endValue ? this.getDateStringFromDate(this.props.endValue) : false,
        required: true
      }), this.props.endValue !== false ? __jsx(Clear, {
        height: this.props.height ? this.props.height : "34px",
        onClick: function onClick() {
          _this2.onChange(_this2.props.startValue, null);
        }
      }, __jsx(_OzIcon.default, {
        size: "14px",
        name: "x",
        color: _consts.BLACKPEARL
      })) : null) : null)) : null, __jsx(CalendarGroup, {
        width: this.props.width ? this.props.width : "260px"
      }, __jsx(CalendarPrevButton, {
        onClick: function onClick() {
          return _this2.setMonth(-1);
        }
      }, __jsx(_OzIcon.default, {
        name: "arrow-left",
        size: "16px"
      })), __jsx(CalendarNextButton, {
        onClick: function onClick() {
          return _this2.setMonth(1);
        }
      }, __jsx(_OzIcon.default, {
        name: "arrow-right",
        size: "16px"
      })), __jsx(Calendar, null, __jsx(CalendarHead, null, this.getMonthStr(this.state.month), " ", this.state.year), __jsx(CalendarBody, null, __jsx("div", {
        className: "c-container"
      }, __jsx(Weekdays, null, ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(function (d, i) {
        return __jsx(Weekday, {
          key: i
        }, d);
      })), __jsx(Days, null, this.state.monthDetails.map(function (day, index) {
        return __jsx(DayContainer, {
          key: index,
          isDisabled: day.month !== 0,
          isSelected: _this2.isSameDay(new Date(day.timestamp), _this2.props.value) || _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) || _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue),
          isBetweenSelected: _this2.props.startValue <= new Date(day.timestamp) && new Date(day.timestamp) <= _this2.props.endValue,
          isStart: _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) && _this2.props.startValue < _this2.props.endValue,
          isEnd: _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue) && _this2.props.startValue < _this2.props.endValue
        }, __jsx(Day, {
          height: _this2.props.height ? _this2.props.height : "34px",
          isDisabled: day.month !== 0,
          isToday: _this2.isSameDay(new Date(day.timestamp), new Date(Date.now())),
          isSelected: _this2.isSameDay(new Date(day.timestamp), _this2.props.value) || _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) || _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue),
          isBetweenSelected: _this2.props.startValue <= new Date(day.timestamp) && new Date(day.timestamp) <= _this2.props.endValue,
          onClick: function onClick() {
            if (_this2.props.type === "range") {
              if (!_this2.state.rangeStart) {
                _this2.onChange(day.timestamp, day.timestamp);

                _this2.setState({
                  rangeStart: day.timestamp
                });
              } else {
                if (_this2.state.rangeStart < day.timestamp) {
                  _this2.onChange(_this2.state.rangeStart, day.timestamp);
                } else {
                  _this2.onChange(day.timestamp, _this2.state.rangeStart);
                }

                _this2.setState({
                  rangeStart: null
                });
              }
            } else {
              _this2.onChange(day.timestamp);
            }
          }
        }, __jsx(DayNumber, null, day.date)));
      }))))), this.props.type === "range" ? __jsx(Calendar, null, __jsx(CalendarHead, null, this.getMonthStr(this.state.month === 11 ? 0 : this.state.month + 1), " ", this.state.month === 11 ? this.state.year + 1 : this.state.year), __jsx(CalendarBody, null, __jsx("div", {
        className: "c-container"
      }, __jsx(Weekdays, null, ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(function (d, i) {
        return __jsx(Weekday, {
          key: i
        }, d);
      })), __jsx(Days, null, this.getMonthDetails(this.state.month === 11 ? this.state.year + 1 : this.state.year, this.state.month === 11 ? 0 : this.state.month + 1).map(function (day, index) {
        return __jsx(DayContainer, {
          key: index,
          isDisabled: day.month !== 0,
          isSelected: _this2.isSameDay(new Date(day.timestamp), _this2.props.value) || _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) || _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue),
          isBetweenSelected: _this2.props.startValue <= new Date(day.timestamp) && new Date(day.timestamp) <= _this2.props.endValue,
          isStart: _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) && _this2.props.startValue < _this2.props.endValue,
          isEnd: _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue) && _this2.props.startValue < _this2.props.endValue
        }, __jsx(Day, {
          height: _this2.props.height ? _this2.props.height : "34px",
          isDisabled: day.month !== 0,
          isToday: _this2.isSameDay(new Date(day.timestamp), new Date(Date.now())),
          isSelected: _this2.isSameDay(new Date(day.timestamp), _this2.props.value) || _this2.isSameDay(new Date(day.timestamp), _this2.props.startValue) || _this2.isSameDay(new Date(day.timestamp), _this2.props.endValue),
          isBetweenSelected: _this2.props.startValue <= new Date(day.timestamp) && new Date(day.timestamp) <= _this2.props.endValue,
          onClick: function onClick() {
            if (_this2.props.type === "range") {
              if (!_this2.state.rangeStart) {
                _this2.onChange(day.timestamp, day.timestamp);

                _this2.setState({
                  rangeStart: day.timestamp
                });
              } else {
                if (_this2.state.rangeStart < day.timestamp) {
                  _this2.onChange(_this2.state.rangeStart, day.timestamp);
                } else {
                  _this2.onChange(day.timestamp, _this2.state.rangeStart);
                }

                _this2.setState({
                  rangeStart: null
                });
              }
            } else {
              _this2.onChange(day.timestamp);
            }
          }
        }, __jsx(DayNumber, null, day.date)));
      }))))) : null), this.props.periods && this.props.periods.length > 0 ? __jsx(Periods, null, __jsx(PeriodsLabel, null, "Periods"), __jsx(PeriodsButtons, null, this.props.periods.map(function (period) {
        return __jsx(_OzButton.default, {
          size: "small",
          variant: "push-black",
          onClick: function onClick(e) {
            var start = new Date(period.start);
            var end = new Date(period.end);

            _this2.onChange(start, end);

            _this2.setState({
              year: start.getFullYear(),
              month: start.getMonth(),
              monthDetails: _this2.getMonthDetails(start.getFullYear(), start.getMonth())
            });
          }
        }, period.label);
      }))) : null, this.props.shortcuts ? __jsx(Periods, null, __jsx(PeriodsLabel, null, "Shortcuts"), __jsx(PeriodsButtons, null, __jsx(_OzButton.default, {
        size: "small",
        variant: "push-black",
        onClick: function onClick(e) {
          var start = new Date();
          var end = new Date();

          _this2.onChange(start, end);

          _this2.setState({
            year: start.getFullYear(),
            month: start.getMonth(),
            monthDetails: _this2.getMonthDetails(start.getFullYear(), start.getMonth())
          });
        }
      }, "Today"), __jsx(_OzButton.default, {
        size: "small",
        variant: "push-black",
        onClick: function onClick(e) {
          var start = new Date();
          var end = new Date();
          start.setDate(start.getDate() - 1);
          end.setDate(end.getDate() - 1);

          _this2.onChange(start, end);

          _this2.setState({
            year: start.getFullYear(),
            month: start.getMonth(),
            monthDetails: _this2.getMonthDetails(start.getFullYear(), start.getMonth())
          });
        }
      }, "Yesterday"), this.props.type === "range" ? __jsx(_react.default.Fragment, null, __jsx(FormGroup, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "50px",
        height: "26px" // type={"number"}
        ,
        onChange: function onChange(e) {
          return _this2.setState({
            "shortcutDays": !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0
          });
        },
        value: this.state.shortcutDays
      }), __jsx(_OzButton.default, {
        size: "small",
        variant: "push-black",
        onClick: function onClick(e) {
          var start = new Date();
          var end = new Date();
          start.setDate(start.getDate() - (parseInt(_this2.state.shortcutDays) > 0 ? parseInt(_this2.state.shortcutDays) - 1 : 0));

          _this2.onChange(start, end);

          _this2.setState({
            year: start.getFullYear(),
            month: start.getMonth(),
            monthDetails: _this2.getMonthDetails(start.getFullYear(), start.getMonth())
          });
        }
      }, "last days")), __jsx(FormGroup, null, __jsx(Input, {
        variant: this.props.variant ? this.props.variant : "default",
        width: "50px",
        height: "26px" // type={"number"}
        ,
        onChange: function onChange(e) {
          return _this2.setState({
            "shortcutWeeks": !isNaN(parseFloat(e.target.value)) ? parseFloat(e.target.value) : 0
          });
        },
        value: this.state.shortcutWeeks
      }), __jsx(_OzButton.default, {
        size: "small",
        variant: "push-black",
        onClick: function onClick(e) {
          var start = new Date();
          var end = new Date();
          start.setDate(start.getDate() - (parseInt(_this2.state.shortcutWeeks) > 0 ? parseInt(_this2.state.shortcutWeeks) * 7 + 1 : 0));

          _this2.onChange(start, end);

          _this2.setState({
            year: start.getFullYear(),
            month: start.getMonth(),
            monthDetails: _this2.getMonthDetails(start.getFullYear(), start.getMonth())
          });
        }
      }, "last weeks"))) : null)) : null) : null), __jsx(ClickCatcher, {
        open: this.state.open,
        onClick: function onClick() {
          return _this2.setState({
            open: false
          });
        }
      }));
    }
  }]);
  return OzDatepicker;
}(_react.Component);

exports.default = OzDatepicker;